module.exports = __webpack_public_path__ + "img/asset5.0b68e7a5.svg";